var _styled;

// https://github.com/alphagov/govuk-frontend/tree/master/src/components/
import styled from 'react-emotion';
import React from 'react';
import PropTypes from 'prop-types';
import { BLACK, YELLOW, ERROR_COLOUR } from 'govuk-colours';
import { withWhiteSpace } from '@govuk-react/hoc';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
var StyledInput = styled('input')((_styled = {
  boxSizing: 'border-box',
  fontFamily: NTA_LIGHT,
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  fontWeight: 400,
  textTransform: 'none',
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_19,
  lineHeight: LINE_HEIGHT.SIZE_19,
  width: '50%'
}, _styled.width = '100%', _styled.padding = '5px 4px 4px', _styled.border = "2px solid " + BLACK, _styled[':focus'] = {
  outline: "3px solid " + YELLOW,
  outlineOffset: 0
}, _styled), function (_ref) {
  var error = _ref.error,
      errorColor = _ref.errorColor;
  return {
    border: error ? "4px solid " + (errorColor || ERROR_COLOUR) : undefined
  };
});

var Input = function Input(props) {
  return React.createElement(StyledInput, props);
};

Input.defaultProps = {
  value: undefined,
  onChange: undefined,
  type: 'text',
  errorColor: undefined
};
Input.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.string,
  onChange: PropTypes.func,
  type: PropTypes.string,
  errorColor: PropTypes.string
} : {};
export default withWhiteSpace({
  marginBottom: 0
})(Input);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/input/es/index.js
// module id = 25
// module chunks = 0